export const container = {
    pageToolbar: {
        collection_data: 'Collection',
        contacts: 'Contacts',
        maintenance: 'Maintenance',
        soon: 'Soon',
        clientChat: 'ai assistant',
        marketplace: 'Recommended',
    },
    changeApartment: 'Change apartment',
}
